var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.94,14.38a6.9,6.9,0,0,0,4.28-1.48l4.6,4.6L17,16.32l-4.6-4.6a6.94,6.94,0,0,0-4-11A6.92,6.92,0,0,0,.68,4.45a6.94,6.94,0,0,0,6.26,9.93Zm0-12.21A5.27,5.27,0,0,1,8,12.61a5.28,5.28,0,0,1-5.41-2.24,5.26,5.26,0,0,1,4.38-8.2Z","transform":"translate(0 -0.5)"}));
}

Search.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 17 17"};

module.exports = Search;

Search.default = Search;
